module.exports = __webpack_public_path__ + "img/book13.5d2dd61b.jpg";